







































































import Vue from 'vue';
import draggable from 'vuedraggable';
import { draggableDelay } from '@/web/utils/draggable';
import { cloneDeep } from 'lodash';
import { mapGetters } from 'vuex';

import TopNav from '@/web/components/navigation/TopNav.vue';
import NavItem from '@/web/components/navigation/NavItem.vue';
import UpgradeYourPlanModal from '@/web/components/settings/UpgradeYourPlanModal.vue';
import InstructorFormModal from '@/web/components/media-library/InstructorFormModal.vue';
import { getConfig } from '@/web/utils/configuration';

export default Vue.extend({
  components: {
    TopNav,
    NavItem,
    draggable,
  },
  data() {
    return {
      draggableDelay,
      sortedInstructors: [],
    };
  },
  computed: {
    ...mapGetters('mediaLibrary', ['canAddInstructor', 'instructors']),
    isLoading() {
      return !this.$store.state.mediaLibrary?.instructors;
    },
    showEmpty() {
      return !this.$store.state.mediaLibrary?.instructors?.length;
    },
    config() {
      return getConfig();
    },
  },
  methods: {
    addInstructor() {
      if (this.canAddInstructor) {
        this.$modal.show(InstructorFormModal);
      } else {
        this.$modal.show(UpgradeYourPlanModal);
      }
    },
    editInstructor(instructor) {
      this.$modal.show(InstructorFormModal, { instructor });
    },
    deleteInstructor({ id }) {
      this.$store.dispatch('mediaLibrary/deleteInstructor', id);
      this.sortedInstructors = this.sortedInstructors.filter(
        item => item.id !== id
      );
    },
    sortPosition(items) {
      this.sortedInstructors = items.sort((a, b) => a.position - b.position);
    },
    async reorderInstructors(): Promise<void> {
      const instructors = this.sortedInstructors.map((instructor, index) => {
        return {
          ...instructor,
          position: index,
          image: instructor.image?.id,
        };
      });
      await this.$store.dispatch(
        'mediaLibrary/reorderInstructors',
        instructors
      );
      await this.$store.dispatch('mediaLibrary/getInstructors');
    },
  },
  async mounted() {
    await this.$store.dispatch('mediaLibrary/getInstructors');
    this.sortPosition([...this.instructors]);
  },
  watch: {
    instructors: {
      handler(value) {
        this.sortPosition([...this.instructors]);
      },
    },
  },
});
